import React from "react";

import {
  Autocomplete,
  Chip,
  FormHelperText,
  MenuItem,
  TextField,
} from "@mui/material";
import { useController } from "react-hook-form";

import { ReactComponent as Arrow } from "../../../Assets/Images/ArrowDown.svg";
import { ReactComponent as Cross } from "../../../Assets/Images/Cross.svg";
import { Theme } from "../../../Style/Theme";
import { FormItemsWrap } from "../../molecules/Wrap/Wrap";
import { Text1 } from "../Typography/Text/Text";
import Label from "./Label";

export const AutoComplete = ({
  control,
  label,
  name,
  getOptionLabel,
  options,
  size,
  menuItemKey,
  fullWidth,
  required,
  placeholder,
  setDoctorMasterData,
  value,
  clearIcon,
}) => {
  const { field, fieldState } = useController({
    control: control,
    name: name,
  });

  const Option = (props) => {
    return (
      <MenuItem {...props} style={{ fontSize: "13px", color: "#37373A" }}>
        {props.children}
      </MenuItem>
    );
  };
  return (
    <FormItemsWrap>
      <Label label={label} required={required} />

      <Autocomplete
        clearIcon={clearIcon || undefined}
        fullWidth={fullWidth}
        variant="outlined"
        getOptionLabel={getOptionLabel}
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "pre",
          width: "100%",
          "& .MuiAutocomplete-popupIndicator": {
            marginTop: "calc(54% - .5em)",
            backgroundColor: "transparent",
            marginRight: "11px",
          },
          "& .MuiTouchRipple-root": {
            display: "none",
          },
        }}
        popupIcon={<Arrow height={"16px"} width={"16px"} />}
        placeholder={placeholder}
        defaultValue={value}
        onChange={(e, data) => {
          setDoctorMasterData((prev) => {
            return {
              ...prev,
              selectedSpeciality: data,
            };
          });
          field.onChange(data ? data[menuItemKey].toString() : "");
        }}
        renderOption={(props, option) => (
          <Option {...props}>{getOptionLabel(option)}</Option>
        )}
        renderInput={(params) => (
          <TextField {...params} error={fieldState?.invalid} placeholder={placeholder} />
        )}
        options={options}
      />

      {fieldState?.error?.message && (
        <FormHelperText style={{ color: "red" }}>
          {fieldState?.error?.message}
        </FormHelperText>
      )}
    </FormItemsWrap>
  );
};

export const Multicomplete = ({
  control,
  label,
  name,
  getOptionLabel,
  options,
  size,
  menuItemKey,
  fullWidth,
  required,
  placeholder,
  value,
  clearIcon,
}) => {
  const { field, fieldState } = useController({
    control: control,
    name: name,
  });
  const Option = (props) => {
    return (
      <MenuItem {...props} style={{ fontSize: "13px", color: "#37373A" }}>
        {props.children}
      </MenuItem>
    );
  };

  return (
    <FormItemsWrap height={"auto"}>
      <Label label={label} required={required} />
      <Autocomplete
        limitTags={2}
        clearIcon={clearIcon || undefined}
        fullWidth={fullWidth}
        multiple
        variant="outlined"
        getOptionLabel={getOptionLabel}
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "pre",
          width: "100%",
          "& .MuiAutocomplete-popupIndicator": {
            marginTop: "calc(54% - .5em)",
            backgroundColor: "transparent",
            marginRight: "11px",
          },
          "& .MuiTouchRipple-root": {
            display: "none",
          },
          "& .MuiOutlinedInput-root":{
            height:"auto",
          }
        }}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        freeSolo={false}
        popupIcon={<Arrow height={"16px"} width={"16px"} />}
        placeholder={placeholder}
        value={value || []}
        onChange={(e, data) => {
          field.onChange(data);
        }}
        renderOption={(props, option) => (
          <Option {...props}>{getOptionLabel(option)}</Option>
        )}
        renderInput={(params) => (
          <TextField {...params} error={fieldState?.invalid} placeholder={placeholder} />
        )}
        options={options}
      />

      {fieldState?.error?.message && (
        <FormHelperText style={{ color: "red" }}>
          {fieldState?.error?.message}
        </FormHelperText>
      )}
    </FormItemsWrap>
  );
};

export const TagsAutocomplete = ({
  control,
  name,
  options,
  label,
  required,
  limitTags,
  getOptionLabel,
  sublabel
}) => {
  const {
    field: { onChange, value },
    fieldState,
  } = useController({
    name,
    control,
  });
  return (
    <FormItemsWrap height={"auto"}>
      <Label label={label} required={required} />
      {sublabel && (
        <Text1 text={sublabel} color={Theme.palette.text.gray03Light} />
      )}
      <Autocomplete
        sx={{
          "& .MuiOutlinedInput-root": {
            padding: 0,
            paddingX: "13px",
            height: "100%",
          },
        }}
        value={value || []}
        limitTags={limitTags}
        clearIcon={false}
        options={options ?? []}
        freeSolo
        getOptionLabel={getOptionLabel}
        onChange={(_, newValue) => {
          onChange(newValue.filter((tag) => tag?.trim()));
        }}
        multiple
        renderTags={(value, props) =>
          value.map((option, index) => (
            <Chip
              label={option}
              {...props({ index })}
              style={{
                backgroundColor: "#86DD9B",
                display: "flex",
                alignContent: "center",
              }}
              deleteIcon={<Cross />}
            />
          ))
        }
        renderInput={(params) => (
          <TextField {...params} error={fieldState?.invalid} />
        )}
      />
      {fieldState?.error?.message && (
        <FormHelperText>{fieldState?.error?.message}</FormHelperText>
      )}
    </FormItemsWrap>
  );
};
